import { zodResolver } from '@hookform/resolvers/zod';
import { FormProvider, useForm } from 'react-hook-form';
import { ErrorMessage, Input } from '#components/atoms/forms/index.ts';
import type { ConfigOverride } from '#dn-types/host.ts';
import { configOverridesDefaultValues } from '#schemas/config-override/config-overrides-default-values.ts';
import { schemas, type OverrideFormData } from './form-data.ts';
import { SingleConfigForm } from './parts/SingleConfigForm.tsx';

const OVERRIDE_KEY = 'punchy.respond_delay';
const DEFAULT_VALUES = { punchy: { respond_delay: configOverridesDefaultValues.punchy.respond_delay } };
const schema = schemas[OVERRIDE_KEY];
type FormData = OverrideFormData[typeof OVERRIDE_KEY];

type Props = {
  defaultValues?: FormData;
  onSave: (overrides: ConfigOverride[]) => void;
};

export function PunchyRespondDelay({ defaultValues, onSave }: Props) {
  const formContext = useForm({
    resolver: zodResolver(schema),
    defaultValues: defaultValues ?? DEFAULT_VALUES,
  });

  const error = formContext.formState.errors.punchy?.respond_delay;

  return (
    <FormProvider {...formContext}>
      <SingleConfigForm overrideKey={OVERRIDE_KEY} onSave={onSave}>
        <Input
          {...formContext.register(OVERRIDE_KEY)}
          type="text"
          placeholder="5s"
          className="width-100"
          hasError={Boolean(error)}
        />
        {error && <ErrorMessage>{error.message?.toString()}</ErrorMessage>}
      </SingleConfigForm>
    </FormProvider>
  );
}
